import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'

import FormControlLabel from '@material-ui/core/FormControlLabel'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Collapse from '@material-ui/core/Collapse'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'


import { getBreakpointsEnable } from '../../../lib';
import { OPENING_RULE, editModeType, operationModeType, decisionType } from '../../../constants';
import { ControlButtons, Word } from '../../../containers';
import { isUndefined } from 'util';
import { WID } from '../../../constants/Language';

const CONTROL_CARD_TYPES = {
  NONE: 'NONE',
  SOOSYRV8_SWAP1: 'SOOSYRV8_SWAP1',
  SOOSYRV8_FIVE_MOVE_NUMBER: 'SOOSYRV8_FIVE_MOVE_NUMBER',
  SOOSYRV8_SWAP2: 'SOOSYRV8_SWAP2',
  SOOSYRV8_FIVE_MOVES: 'SOOSYRV8_FIVE_MOVES',
}

const fiveMoveNumberItems = [
  { value: '0', label: '' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
]

const stylesForControlCardContent = theme => ({

})


const OpeningRuleControlBox = withStyles(stylesForControlCardContent, { withTheme: true })((props) => {
  const { type, padding, gameInfo, OpeningRuleControlBoxDispatch } = props
  var styles, openingRuleControlBox
  styles = {
    openingRuleControlBox: {
      padding
    }
  }
  switch(type) {
    case CONTROL_CARD_TYPES.SOOSYRV8_SWAP1:
      openingRuleControlBox = <Soosyrv8Swap1Box {...{ ...OpeningRuleControlBoxDispatch.Soosyrv8Swap1BoxDispatch }}/>
      break
    case CONTROL_CARD_TYPES.SOOSYRV8_FIVE_MOVE_NUMBER:
      openingRuleControlBox = <Soosyrv8FiveMoveNumberBox {...{ gameInfo, ...OpeningRuleControlBoxDispatch.Soosyrv8FiveMoveNumberBox }}/>
      break
    case CONTROL_CARD_TYPES.SOOSYRV8_SWAP2:
      openingRuleControlBox = <Soosyrv8Swap2Box {...{ ...OpeningRuleControlBoxDispatch.Soosyrv8Swap1BoxDispatch }}/>
      break
    case CONTROL_CARD_TYPES.SOOSYRV8_FIVE_MOVES:
      openingRuleControlBox = <Soosyrv8FiveMovesBox  {...{ gameInfo, ...OpeningRuleControlBoxDispatch.Soosyrv8FiveMoveNumberBox }}/>
      break
    default:
      return (<div></div>)
  }
  return (
    <div style={styles.openingRuleControlBox}>
      {openingRuleControlBox}
    </div>
  )
})

const stylesForSoosyrv8Swap1Box = theme => ({
})

const Soosyrv8Swap1Box = withStyles(stylesForSoosyrv8Swap1Box, { withTheme: true })(props => {
  const { classes, handleClickSwapButton } = props
  return (
    <Grid container spacing={16}>
      <Grid item xs={12}>
        <Typography align='center'><Word wid={WID.CONTROL_CARD.SOOSYRV8_SWAP_BOX.MESSAGE_DO_YOU_SWAP}/></Typography>
      </Grid>
      <Grid item xs={6}>
        <Button
          variant='contained'
          fullWidth
          className={classes.button}
          color='primary'
          onClick={handleClickSwapButton(true)}
        >
          <Word wid={WID.CONTROL_CARD.SOOSYRV8_SWAP_BOX.YES_BUTTON}/>
        </Button>
      </Grid>
      <Grid item xs={6}>
        <Button
          variant='contained'
          fullWidth
          className={classes.button}
          onClick={handleClickSwapButton(false)}
        >
          <Word wid={WID.CONTROL_CARD.SOOSYRV8_SWAP_BOX.NO_BUTTON}/>
        </Button>
      </Grid>
    </Grid>
  )
})

const stylesForSoosyrv8FiveMoveNumberBox = theme => ({
  textField: {
    width: 100,
    margin: theme.spacing.unit * 2,
  }
})

const Soosyrv8FiveMoveNumberBox = withStyles(stylesForSoosyrv8FiveMoveNumberBox, { withTheme: true })(props => {
  const { classes, gameInfo, handleChangedFiveMoveNumber, handleClickDecisionButton } = props
  var disabled
  disabled = {
    decisionButton: Boolean(gameInfo.soosyrv8.fiveMoveNumber === 0)
  }
  return (
    <Grid container spacing={16}>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <TextField
              select
              className={classes.textField}
              onChange={handleChangedFiveMoveNumber}
              value={gameInfo.soosyrv8.fiveMoveNumber.toString(10)}
            >
              {fiveMoveNumberItems.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
              )}
            </TextField>
          }
          labelPlacement='start'
          label={<Word wid={WID.CONTROL_CARD.SOOSYRV8_FIVE_MOVE_NUMBER_BOX.MESSAGE_DECLARE_NUMBER_OF_FIFTH_MOVES}/>}
        />
        <Button
          variant='contained'
          color='primary'
          className={classes.button}
          onClick={handleClickDecisionButton(decisionType.SOOSYRV8_FIVE_MOVE_NUMBER)}
          disabled={disabled.decisionButton}
        >
          {<Word wid={WID.CONTROL_CARD.SOOSYRV8_FIVE_MOVE_NUMBER_BOX.OK_BUTTON}/>}
        </Button>
      </Grid>
    </Grid>
  )
})

const stylesForSoosyrv8Swap2Box = theme => ({
})

const Soosyrv8Swap2Box = withStyles(stylesForSoosyrv8Swap2Box, { withTheme: true })(props => {
  const { classes, handleClickSwapButton } = props
  return (
    <Grid container spacing={16}>
      <Grid item xs={12}>
        <Typography align='center'>{<Word wid={WID.CONTROL_CARD.SOOSYRV8_SWAP_BOX.MESSAGE_DO_YOU_SWAP}/>}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Button
          variant='contained'
          fullWidth
          className={classes.button}
          color='primary'
          onClick={handleClickSwapButton(true)}
        >
          {<Word wid={WID.CONTROL_CARD.SOOSYRV8_SWAP_BOX.YES_BUTTON}/>}
        </Button>
      </Grid>
      <Grid item xs={6}>
        <Button
          variant='contained'
          fullWidth
          className={classes.button}
          onClick={handleClickSwapButton(false)}
        >
          {<Word wid={WID.CONTROL_CARD.SOOSYRV8_SWAP_BOX.NO_BUTTON}/>}
        </Button>
      </Grid>
    </Grid>
  )
})

const stylesForSoosyrv8FiveMovesBox = theme => ({
  box: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  }
})

const Soosyrv8FiveMovesBox = withStyles(stylesForSoosyrv8FiveMovesBox, { withTheme: true })(props => {
  const { classes, handleClickDecisionButton } = props
  return (
    <Grid container spacing={16}>
      <Grid item xs={12}>
        <div className={classes.box}>
          <Typography align='center'>{<Word wid={WID.CONTROL_CARD.SOOSYRV8_FIVE_MOVES_BOX.MESSAGE_IS_IT_OK}/>}</Typography>
          <Button
            variant='contained'
            className={classes.button}
            color='primary'
            onClick={handleClickDecisionButton(decisionType.SOOSYRV8_FIVE_MOVES)}
          >
            {<Word wid={WID.CONTROL_CARD.SOOSYRV8_FIVE_MOVES_BOX.OK_BUTTON}/>}
          </Button>
        </div>
      </Grid>
    </Grid>
  )
})

const styles = theme => ({
  fixedBox: {
    flexGrow: 1,
    position: 'fixed',
    zIndex: 1000,
    width: '100%',
    maxWidth: 400,
    margin: `0 auto`,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.palette.common.white,
    textAlign: 'center',
    border: `1px solid ${theme.palette.grey[200]}`,
  },
  card: {
    textAlign: 'center',
    marginBottom: theme.spacing.unit * 2,
    padding: theme.spacing.unit,
  },
  cardContent: {
    textAlign: 'center',
    padding: 0,
  },
  openingRuleControlBox: {
    padding: theme.spacing.unit * 2,
    borderBottom: `1px solid ${theme.palette.grey[200]}`
  }
})

class ControlCard extends React.Component {
  state = {
    open: false,
    visibleFixedBox: true,
    type: CONTROL_CARD_TYPES.NONE,
  }

  componentDidMount() {
    window.onscroll = (event) => {
      let elem, rect
      if (this.props.bid === undefined) {
        return
      }
      elem = document.getElementById( `bid-${this.props.bid}` )
      if (elem === null) {
        return
      }
      rect = elem.getBoundingClientRect()
      if (this.state.visibleFixedBox === true && rect.height * 0.4 + rect.top < 0) {
        this.setState({ visibleFixedBox: false })
      }
      else if (this.state.visibleFixedBox === false && rect.height * 0.3 + rect.top > 0) {
        this.setState({ visibleFixedBox: true })
      }
    }
  }

  componentWillUnmount() {
    if (window.onscroll !== null) {
      window.onscroll = null
    }
  }

  componentWillReceiveProps(nextProps) {
    if (isUndefined(nextProps.gameInfo) || isUndefined(nextProps.moves)) {
      return true
    }
    switch (nextProps.gameInfo.openingRule) {
      case OPENING_RULE.SOOSYRV8:
        switch (nextProps.moves.length) {
          case 4:
            this.setState({ open: true, type: CONTROL_CARD_TYPES.SOOSYRV8_SWAP1 })
            break
          case 6:
            this.setState({ open: true, type: CONTROL_CARD_TYPES.SOOSYRV8_FIVE_MOVE_NUMBER })
            break
          case 7:
            this.setState({ open: true, type: CONTROL_CARD_TYPES.SOOSYRV8_SWAP2 })
            break
          case 8:
            if (nextProps.gameInfo.soosyrv8.fiveMoveNumber === nextProps.gameInfo.soosyrv8.fiveMoves.length) {
              this.setState({ open: true, type: CONTROL_CARD_TYPES.SOOSYRV8_FIVE_MOVES })
            }
            else if (this.state.open === true) {
              this.setState({ open: false })
            }
            break
          default: 
            if (this.state.open === true) {
              this.setState({ open: false })
            }
            break
        }
        break
      default:
        if (this.state.open === true || this.state.type !== CONTROL_CARD_TYPES.NONE) {
          this.setState({ open: false })
        }
        break
    }
  }
  
  render() {
    const { classes, theme, width, component, bid, gameInfo, editMode, operationMode, isVisibleControlButtons, isVisibleOpeningRuleControlBox, OpeningRuleControlBoxDispatch } = this.props
    const { open, type, visibleFixedBox } = this.state
    const { md } = getBreakpointsEnable(theme, width)
    var visible
    visible = {
      controlButtons: Boolean(
        isVisibleControlButtons !== false &&
        (
          editMode !== editModeType.PUZZLE ||
          operationMode !== operationModeType.EDIT
        )
      ),
      openingRuleControlBox: Boolean(
        open &&
        isVisibleOpeningRuleControlBox !== false &&
        editMode === editModeType.NORMAL &&
        operationMode === operationModeType.EDIT
      )
    }

    return md && component === 'CardContent' ? (
      <CardContent className={classes.cardContent}>
        <Collapse in={visible.openingRuleControlBox}>
          <div className={classes.openingRuleControlBox}>
            <OpeningRuleControlBox {...{ type, gameInfo, OpeningRuleControlBoxDispatch }}/>
          </div>
        </Collapse>
      </CardContent>
    ) : md ? (
      <Collapse in={visible.openingRuleControlBox}>
        <Card className={classes.card}>
          <CardContent>
            <OpeningRuleControlBox {...{ type, gameInfo, OpeningRuleControlBoxDispatch }}/>
          </CardContent>
        </Card>
      </Collapse>
    ) : (
      <div className={classes.fixedBox}>
        <Collapse in={visible.openingRuleControlBox && visibleFixedBox}>
          <OpeningRuleControlBox {...{ type, padding: theme.spacing.unit * 2, gameInfo, OpeningRuleControlBoxDispatch }}/>
        </Collapse>
        {bid >= 0 && (
          <Collapse in={visible.controlButtons && visibleFixedBox}>
            <ControlButtons bid={bid}/>
          </Collapse>
        )}
      </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(ControlCard)



// WEBPACK FOOTER //
// ./src/components/Common/RenjuBoardCard/ControlCard.js